// SMFT30Arabic.js
// This component implements the Arabic version of the SMFT-30 test with:
// - Pagination: 3 questions per page/section
// - Card style for each question matches the original SMFT-30 test (see inline style on question-block)
// - Cancel and Next/Submit buttons horizontally aligned and styled like the original
// - All logic and UI are commented for clarity

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./SMFT.css";
import { BASE_URL } from "../../Config";
import logoImage from "../../../resources/1000028180.jpeg";
import { FiMenu } from 'react-icons/fi';

const questions = [
  "أستعيد سريعًا توازني بعد الانتكاسات أو الأخطاء.",
  "أستطيع الحفاظ على التركيز والهدوء تحت الضغط.",
  "أرى التحديات كفرص للنمو",
  "أؤمن بقدراتي على تقديم أداء جيد.",
  "أستطيع البقاء واثقًا حتى عند مواجهة خصوم صعبين.",
  "أثق في تدريبي واستعدادي",
  "أستطيع الحفاظ على التركيز خلال المنافسات.",
  "أستعيد التركيز بسرعة بعد الانحرافات.",
  "أضع أهدافًا محددة للحفاظ على انتباهي على المهمة الحالية",
  "أستطيع تعديل استراتيجيتي استجابةً للوضعيات المتغيرة.",
  "أنا مستعد لاستقبال وجهات النظر الاخرين وعلى استعداد للتعديل.",
  "أظل هادئًا في حالات غير متوقعة أو فوضوية.",
  "أنا متحمس للتحسين وتحقيق إمكانياتي الكاملة.",
  "أظل متحفزًا حتى في مواجهة التحديات.",
  "أجد السرور والرضا في عملية التحسين.",
  "أؤدي بشكل جيد في الحالات ذات الضغط العالي.",
  "أستخدم الضغط كدافع بدلاً من عائق.",
  "أظل هادئًا ومركزًا في اللحظات الحاسمة.",
  "أدير عواطفي بفعالية خلال المنافسات.",
  "أظل هادئًا في وجه الصعوبات.",
  "أستخدم الحديث الذاتي الإيجابي للتغلب على العواطف السلبية.",
  "أشعر بالراحة بتحمل دور القيادة عند الحاجة",
  "أدعم زملائي وأعزز بيئة فريق إيجابية",
  "أتواصل بشكل جيد مع زملائي في وخارج الميدان",
  "أنا فعّال في وضع وتحقيق الأهداف الشخصية.",
  "أحتفظ بمستوى عالٍ من الدافع حتى بدون حوافز خارجية.",
  "أدفع نفسي باستمرار للتحسين والتفوق",
  "لدي تقنيات فعالة لإدارة الضغط",
  "أستطيع التعرف عندما يؤثر الضغط على أدائي واتخاذ إجراء تصحيحي",
  "أحافظ على توازن صحي بين التدريب والمنافسة والاستراحة.",
  "أدير القلق بشكل جيد، سواء في التدريب أو خلال المنافسة.",
  "لدي استراتيجيات التكيف للتعامل مع أعصاب قبل المباراة.",
  "أستطيع تحويل الطاقة العصبية إلى أداء إيجابي.",
  "أستطيع الحفاظ على التركيز خلال فترات طويلة من المنافسة.",
  "أقلل من الانحرافات وأظل مشاركًا في اللعبة.",
  "أستخدم التصوير الذهني أو الرموز العقلية لتعزيز التركيز.",
  "أستخدم التأكيدات الإيجابية لرفع ثقتي بالنفس.",
  "أستبدل الأفكار السلبية بالحديث الذاتي البناء والتشجيعي.",
  "أحافظ على نهج إيجابي حتى في المواقف التحديثية.",
  "لست متأثرًا بشكل زائد بالتوقعات الخارجية.",
  "أستخدم التوقعات كحافز بدلاً من زيادة الضغط.",
  "أركز على معاييري وأهدافي الشخصية بدلاً من الضغوط الخارجية.",
  "أتعلم من النجاحات والفشل في الألعاب.",
  "أظل هادئًا وأتخذ قرارات منطقية خلال الألعاب.",
  "أقوم بضبط نهجي بسرعة استنادًا إلى تطور الوضع في اللعبة.",
  "لدي رغبة قوية في التحسين المستمر والتفوق.",
  "أنا متحمس للرياضة وعملية التحسين.",
  "أحافظ على مستوى عالٍ من الحماس والتفاني.",
  "أسهم بشكل إيجابي في الكيمياء العامة للفريق.",
  "أنا داعم ومشجع لزملائي في الفريق.",
  "أعمل بنشاط على بناء علاقات قوية مع زملائي داخل وخارج الميدان.",
  "أحافظ على مستوى عالٍ من التركيز خلال جلسات التدريب.",
  "أنا مستمع لتعليمات المدربين وزملائي.",
  "أقلل من الانحرافات وأظل مشاركًا بشكل كامل في أنشطة الفريق.",
  "أتصرف بروح رياضية داخل وخارج الميدان.",
  "ألتزم بقوانين وتوجيهات الفريق بشكل ثابت.",
  "أظهر احترامًا للمدربين والزملاء والخصوم والحكام.",
  "أتعامل مع التحديات بتفاؤل وموقف إيجابي.",
  "أنا مستعد لاستقبال التعليقات والانتقادات البناءة.",
  "أحافظ على موقف عازم وقوي، حتى في المواقف الصعبة.",
  "أدير توقعات الخارج بشكل جيد وأركز على أدائي.",
  "أستخدم التوقعات كحافز بدلاً من مصدر للضغط.",
  "أحافظ على تفكير إيجابي بغض النظر عن الضغوط الخارجية.",
  "لدي شغف حقيقي باللعب والتنافس في هذه الرياضة.",
  "أجد الفرح والإشباع في عملية التدريب واللعب.",
  "حبي للعبة يدفعني باستمرار لتقديم أفضل جهدي.",
];

// Five answer options (Arabic, matching normal SMFT)
const answerLabels = ["أبدًا", "نادراً", "غالبًا", "دائمًا"];
const QUESTIONS_PER_PAGE = 3; // Number of questions per section/page
const TOTAL_SECTIONS = Math.ceil(questions.length / QUESTIONS_PER_PAGE); // Total number of sections

// Section keys for backend and Arabic names for display (corrected order)
const sectionKeys = [
  "resilience",
  "confidence",
  "focus",
  "adaptability",
  "motivation",
  "performance_under_pressure",
  "emotional_control",
  "leadership",
  "goal_setting",
  "stress_management",
  "anxiety_management",
  "sustained_focus",
  "positive_self_talk",
  "external_pressure_management",
  "game_intelligence",
  "drive",
  "team_chemistry",
  "training_focus",
  "sportsmanship",
  "mental_resilience",
  "external_expectations",
  "passion",
];
const sectionNamesArabic = [
  "المرونة",
  "الثقة بالنفس",
  "التركيز",
  "القدرة على التكيف",
  "الدافعية",
  "الأداء تحت الضغط",
  "التحكم العاطفي",
  "القيادة",
  "تحديد الأهداف",
  "إدارة الضغوط",
  "إدارة القلق",
  "التركيز المستمر",
  "الحديث الإيجابي مع النفس",
  "إدارة الضغط الخارجي",
  "ذكاء اللعبة",
  "الدافع",
  "كيمياء الفريق",
  "التركيز في التدريب",
  "الروح الرياضية",
  "المرونة الذهنية",
  "توقعات الآخرين",
  "الشغف",
];

export default function SMFT30Arabic() {
  // State for user responses (question index -> selected value)
  const [responses, setResponses] = useState({});
  const [showInstruction, setShowInstruction] = useState(true);
  const [currentSection, setCurrentSection] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Handle radio button selection for a question
  const handleSelect = (questionIndex, rating) => {
    setResponses({ ...responses, [questionIndex]: rating });
  };

  // Handle Cancel button (navigate back to dashboard)
  const handleCancel = () => {
    navigate("/dashboard");
  };

  // Handle Next Section button
  const handleNext = (e) => {
    e.preventDefault();
    // Validate all questions on this page are answered
    const startIdx = currentSection * QUESTIONS_PER_PAGE;
    const endIdx = Math.min(startIdx + QUESTIONS_PER_PAGE, questions.length);
    for (let i = startIdx; i < endIdx; i++) {
      if (!responses[i]) {
        setAlertMsg("يرجى الإجابة على جميع الأسئلة قبل المتابعة.");
        setShowAlert(true);
        return;
      }
    }
    setCurrentSection((prev) => prev + 1);
  };

  // Handle Submit button (on last section)
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validate all questions on this page are answered
    const startIdx = currentSection * QUESTIONS_PER_PAGE;
    const endIdx = Math.min(startIdx + QUESTIONS_PER_PAGE, questions.length);
    for (let i = startIdx; i < endIdx; i++) {
      if (!responses[i]) {
        setAlertMsg("يرجى الإجابة على جميع الأسئلة قبل المتابعة.");
        setShowAlert(true);
        return;
      }
    }
    setIsSubmitting(true);
    // Build grouped responses by section
    const groupedResponses = {};
    for (let s = 0; s < sectionKeys.length; s++) {
      groupedResponses[sectionKeys[s]] = [
        responses[s * 3] || 0,
        responses[s * 3 + 1] || 0,
        responses[s * 3 + 2] || 0,
      ];
    }
    // Prepare payload for API
    const payload = {
      test_type: "SMFT-30-AR",
      responses: groupedResponses,
    };
    try {
      const token =
        localStorage.getItem("accessToken") || localStorage.getItem("token");
      const response = await fetch(`${BASE_URL}/api/test/submit_test`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error("فشل إرسال الاختبار");
      navigate("/test-summary");
    } catch (error) {
      setAlertMsg("حدث خطأ أثناء إرسال الاختبار. يرجى المحاولة مرة أخرى.");
      setShowAlert(true);
      setIsSubmitting(false);
    }
  };

  // Calculate the questions to show for the current section/page
  const startIdx = currentSection * QUESTIONS_PER_PAGE;
  const endIdx = Math.min(startIdx + QUESTIONS_PER_PAGE, questions.length);
  const sectionQuestions = questions.slice(startIdx, endIdx);
  const currentSectionKey = sectionKeys[currentSection];
  const currentSectionNameArabic = sectionNamesArabic[currentSection];

  // Responsive helper
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 600;

  return (
    <div
      style={
        isMobile
          ? {
              minHeight: '100vh',
              background: `linear-gradient(to top left, #2AA7A1 -25.98%, #E0F7F4 66.42%)`,
              fontFamily: 'Poppins, sans-serif',
            }
          : {
              minHeight: '100vh',
              background: `linear-gradient(to top left, #2AA7A1 -25.98%, #E0F7F4 66.42%)`,
              fontFamily: 'Poppins, sans-serif',
            }
      }
    >
      {/* Header with Logo */}
      <header className="dashboard-header" style={{ position: "static" }}>
        <div
          className="header-content"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            padding: "0 1rem",
            maxWidth: "1200px",
            margin: "0 auto",
          }}
        >
          <div className="header-logo-container">
                                              <img
                        src={logoImage}
                        alt="Power Mind Metrics Logo"
                        style={{ height: "90px", width: "100px", marginRight: "10px" }}
                      />
            <h1 className="header-logo" style={{ whiteSpace: isMobile ? 'nowrap' : undefined, fontSize: isMobile ? 22 : undefined }}>Power Mind Metrics</h1>
          </div>
          {isMobile ? (
            <div className="mobile-nav-menu">
              <button className="hamburger-btn" onClick={() => setMobileMenuOpen(v => !v)} style={{ background: 'none', border: 'none', padding: 0, marginLeft: 0, marginRight: 8 }}>
                <FiMenu size={28} />
              </button>
              {mobileMenuOpen && (
                <div className="mobile-nav-dropdown" style={{ position: 'absolute', top: 60, right: 10, background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.12)', zIndex: 1000, padding: 8 }}>
                  <button className="nav-link" style={{ display: 'block', width: '100%', textAlign: 'left', padding: 8 }} onClick={() => { setMobileMenuOpen(false); navigate('/profile'); }}>Profile</button>
                  <button className="nav-link" style={{ display: 'block', width: '100%', textAlign: 'left', padding: 8 }} onClick={() => { setMobileMenuOpen(false); navigate('/logout'); }}>Logout</button>
                </div>
              )}
            </div>
          ) : (
            <nav className="header-nav" style={{ marginLeft: "auto" }}>
              <button className="nav-link" onClick={() => navigate("/profile")}>Profile</button>
              <button className="nav-link" onClick={() => navigate("/logout")}>Logout</button>
            </nav>
          )}
        </div>
      </header>
      <div
        style={
          isMobile
            ? {
                minHeight: 'calc(100vh - 64px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: 40,
                marginBottom: '110px',
              }
            : {
                minHeight: 'calc(100vh - 64px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: 40,
                marginBottom: 80,
              }
        }
      >
        <div
          style={
            isMobile
              ? {
                  background: '#fff',
                  borderRadius: '1.2rem',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                  width: '100vw',
                  maxWidth: '98vw',
                  minWidth: 0,
                  padding: '1.2rem 0.7rem 1.5rem 0.7rem',
                  boxSizing: 'border-box',
                  margin: 0,
                  marginBottom: '110px',
                  direction: 'rtl',
                  fontFamily: 'Poppins, sans-serif',
                }
              : {
                  background: '#fff',
                  borderRadius: 8,
                  boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                  width: 1028,
                  height: 670,
                  padding: '2rem',
                  direction: 'rtl',
                  fontFamily: 'Poppins, sans-serif',
                }
          }
        >
          {/* Test Title */}
          <h1 className="logo-title" style={{ color: ' rgba(52, 52, 52, 1)' }}>
            اختبار اللياقة العقلية الرياضية SMFT-30 (Arabic)
          </h1>
          {/* Instruction Modal (shown at the start) */}
          {showInstruction ? (
            <div
              style={
                isMobile
                  ? {
                      position: 'fixed',
                      top: 0,
                      left: 0,
                      width: '100vw',
                      height: '100vh',
                      background: 'rgba(52, 52, 52, 1)',
                      zIndex: 9999,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }
                  : {
                      position: 'fixed',
                      top: 0,
                      left: 0,
                      width: '100vw',
                      height: '100vh',
                      background: 'rgba(52, 52, 52, 1)',
                      zIndex: 9999,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }
              }
            >
              <div
                style={
                  isMobile
                    ? {
                        background: '#fff',
                        borderRadius: '1.2rem',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                        padding: '1.2rem 0.7rem 1.5rem 0.7rem',
                        minWidth: 0,
                        maxWidth: '98vw',
                        textAlign: 'right',
                        fontFamily: 'Poppins, sans-serif',
                        direction: 'rtl',
                      }
                    : {
                        background: '#fff',
                        borderRadius: 16,
                        boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                        padding: '2.5rem 2.5rem 2rem 2.5rem',
                        minWidth: 340,
                        maxWidth: 500,
                        textAlign: 'right',
                        fontFamily: 'Poppins, sans-serif',
                        direction: 'rtl',
                      }
                }
              >
                <h2
                  style={{
                    color: '#11998e',
                    fontWeight: 700,
                    fontSize: 24,
                    marginBottom: 12,
                    textAlign: 'center',
                  }}
                >
                  تعليمات الاختبار
                </h2>
                <div
                  style={{
                    color: '#444',
                    fontSize: 18,
                    marginBottom: 18,
                    whiteSpace: 'pre-line',
                    lineHeight: 2,
                  }}
                >
                  عزيزي اللاعب،<br />
                  شكرًا لك على تخصيص الوقت للمشاركة في اختبار اللياقة الذهنية.<br />
                  تهدف نتائج هذا الاختبار إلى إتاحة فرصة للتفكير الذاتي حول مختلف جوانب لياقتك الذهنية.<br />
                  الغرض من هذه النتائج هو مساعدتك على اكتساب فهم أعمق لحالتك الذهنية، وتعزيز إدراكك لنقاط قوتك والمجالات التي قد تحتاج إلى اهتمام. من المهم أن تعلم أن نتائج هذا الاختبار ليست أداة تشخيصية، وهدفها الأساسي هو تشجيع الوعي الذاتي.<br />
                  يرجى الأخذ في الاعتبار أن نتائج هذا الاختبار لا تُعد بديلاً عن أي تشخيص طبي، وإنما تُعد نقطة انطلاق للتفكير الذاتي..
                </div>
                <button
                  className="card-start-btn"
                  style={
                    isMobile
                      ? {
                          background: '#11998e',
                          color: '#fff',
                          fontWeight: 600,
                          fontSize: 18,
                          borderRadius: 8,
                          marginTop: 12,
                          width: '100%',
                        }
                      : {
                          background: '#11998e',
                          color: '#fff',
                          fontWeight: 600,
                          fontSize: 18,
                          borderRadius: 8,
                          marginTop: 12,
                          width: '100%',
                        }
                  }
                  onClick={() => setShowInstruction(false)}
                >
                  متابعة
                </button>
              </div>
            </div>
          ) : (
            // Main Test Form (paginated)
            <form
              className=""
              onSubmit={
                currentSection === TOTAL_SECTIONS - 1
                  ? handleSubmit
                  : handleNext
              }
            >
              {/* Step-based Progress Bar (like MTT-20) */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 12,
                  width: '100%',
                  margin: '16px 0 8px 0',
                }}
              >
                {Array.from({ length: TOTAL_SECTIONS }).map((_, idx) => (
                  <div
                    key={idx}
                    style={{
                      flex: 1,
                      height: 10,
                      borderRadius: 6,
                      background: idx <= currentSection ? '#2AA7A1' : '#e0e0e0',
                      transition: 'background 0.3s',
                    }}
                  />
                ))}
              </div>
              {/* Section progress indicator */}
              <div
                className="progress-text"
                style={{ marginBottom: 16, color: 'rgba(52, 52, 52, 1)' }}
              >
                القسم {currentSection + 1} من {TOTAL_SECTIONS}
              </div>
              {/* Section name in Arabic */}
              <div
                style={{
                  fontWeight: 700,
                  fontSize: 22,
                  color: '#11998e',
                  textAlign: 'center',
                  marginBottom: 8,
                }}
              >
                {currentSectionNameArabic}
              </div>
              {/* Render 3 questions per page as cards */}
              {sectionQuestions.map((question, idx) => {
                const qIdx = startIdx + idx;
                return (
                  <div
                    key={qIdx}
                    style={
                      isMobile
                        ? {
                            background: '#fff',
                            borderRadius: '1.2rem',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                            marginBottom: 12,
                            padding: '1.2rem 0.7rem 1.5rem 0.7rem',
                            boxSizing: 'border-box',
                          }
                        : {
                            background: '#fff',
                            borderRadius: 10,
                            boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                            marginBottom: 12,
                            padding: '15px 20px',
                          }
                    }
                  >
                    <div className="question-text">
                      {qIdx + 1}. {question}
                    </div>
                    {/* Options: desktop = row, mobile = pairs of two */}
                    {isMobile ? (
                      (() => {
                        const pairs = [[1,2],[3,4]];
                        return pairs.map((pair, rowIdx) => (
                          <div key={rowIdx} className="mtt20-options-pair-row">
                            {pair.map((value) => (
                              <label key={value} className="mtt20-option-label">
                                <input
                                  type="radio"
                                  name={`q${qIdx}`}
                                  value={value}
                                  checked={responses[qIdx] === value}
                                  onChange={() => handleSelect(qIdx, value)}
                                  className="mtt20-radio"
                                />
                                <span className="mtt20-option-label-text">{answerLabels[value-1]}</span>
                              </label>
                            ))}
                          </div>
                        ));
                      })()
                    ) : (
                      <div
                        className="options"
                        style={{
                          flexDirection: 'row',
                          gap: 24,
                          justifyContent: 'start',
                          border: 'none',
                          background: 'none',
                        }}
                      >
                        {answerLabels.map((label, i) => (
                          <div key={i}>
                            <label
                              className="option-label"
                              style={{ fontSize: 16, fontWeight: 500 }}
                            >
                              <input
                                type="radio"
                                name={`q${qIdx}`}
                                value={i + 1}
                                checked={responses[qIdx] === i + 1}
                                onChange={() => handleSelect(qIdx, i + 1)}
                                style={{
                                  width: 18,
                                  height: 18,
                                  accentColor: '#11998e',
                                  marginLeft: 6,
                                }}
                              />
                              {label}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
              {/* Button row: Cancel and Next/Submit, horizontally aligned and spaced */}
              <div
                style={
                  isMobile
                    ? {
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: 16,
                        width: '100%',
                        marginTop: 32,
                        marginBottom: 32,
                      }
                    : {
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: 24,
                        width: '100%',
                        marginTop: 32,
                      }
                }
              >
                {/* Cancel button: returns to dashboard */}
                <button
                  type="button"
                  onClick={handleCancel}
                  style={
                    isMobile
                      ? {
                          border: '2px solid #2aa7a1',
                          background: '#fff',
                          color: '#2aa7a1',
                          borderRadius: 8,
                          fontWeight: 500,
                          fontSize: 16,
                          fontFamily: 'Poppins, sans-serif',
                          cursor: 'pointer',
                          transition: 'background 0.2s, color 0.2s',
                          height: 40,
                          width: 107,
                        }
                      : {
                          border: '2px solid #2aa7a1',
                          background: '#fff',
                          color: '#2aa7a1',
                          borderRadius: 8,
                          fontWeight: 500,
                          fontSize: 16,
                          fontFamily: 'Poppins, sans-serif',
                          cursor: 'pointer',
                          transition: 'background 0.2s, color 0.2s',
                          height: 40,
                          width: 107,
                        }
                  }
                >
                  إلغاء
                </button>
                {/* Next/Submit button: advances to next section or submits on last page */}
                <button
                  type="submit"
                  disabled={isSubmitting}
                  style={
                    isMobile
                      ? {
                          border: '2px solid #2aa7a1',
                          background: isSubmitting ? '#9ca3af' : '#fff',
                          color: '#2aa7a1',
                          borderRadius: 8,
                          fontWeight: 500,
                          fontSize: 16,
                          fontFamily: 'Poppins, sans-serif',
                          cursor: isSubmitting ? 'not-allowed' : 'pointer',
                          transition: 'background 0.2s, color 0.2s',
                          height: 40,
                          width: 107,
                        }
                      : {
                          border: '2px solid #2aa7a1',
                          background: isSubmitting ? '#9ca3af' : '#fff',
                          color: '#2aa7a1',
                          borderRadius: 8,
                          fontWeight: 500,
                          fontSize: 16,
                          fontFamily: 'Poppins, sans-serif',
                          cursor: isSubmitting ? 'not-allowed' : 'pointer',
                          transition: 'background 0.2s, color 0.2s',
                          height: 40,
                          width: 107,
                        }
                  }
                >
                  {isSubmitting
                    ? 'جاري الإرسال...'
                    : currentSection === TOTAL_SECTIONS - 1
                    ? 'إرسال'
                    : 'القسم التالي'}
                </button>
              </div>
            </form>
          )}
          {/* Alert modal for validation/errors */}
          {showAlert && (
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                background: 'rgba(0,0,0,0.18)',
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <div
                style={{
                  background: '#fff',
                  borderRadius: 16,
                  boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                  padding: '2.5rem 2.5rem 2rem 2.5rem',
                  minWidth: 340,
                  maxWidth: 400,
                  textAlign: 'center',
                  fontFamily: 'Cairo, Poppins, Segoe UI, sans-serif',
                }}
              >
                <div
                  style={{
                    color: '#b91c1c',
                    fontWeight: 700,
                    fontSize: 20,
                    marginBottom: 12,
                  }}
                >
                  تنبيه
                </div>
                <div style={{ color: '#444', fontSize: 18, marginBottom: 8 }}>
                  {alertMsg}
                </div>
                <button
                  onClick={() => setShowAlert(false)}
                  style={{
                    marginTop: 16,
                    background: '#11998e',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 8,
                    padding: '8px 24px',
                    fontWeight: 600,
                    fontSize: 16,
                    cursor: 'pointer',
                  }}
                >
                  حسنًا
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Footer */}
      <div
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          borderTop: '1px solid rgba(0, 0, 0, 0.1)',
          padding: '12px 0',
          textAlign: 'center',
          fontFamily: 'Poppins, sans-serif',
          zIndex: 100,
        }}
      >
        <p
          style={{
            margin: 0,
            fontSize: '14px',
            color: 'rgba(75, 75, 75, 0.8)',
            fontWeight: 400,
          }}
        >
          © 2025 All rights reserved Power Mind Metrics
        </p>
      </div>
    </div>
  );
}
